import {AnyLicence, CertificatePremisesLicence} from '..';

export const isCertificatePremisesLicence = (licence: AnyLicence): licence is CertificatePremisesLicence => {
  const validLicenceIds = ['certificatePremisesLicence3Year', 'certificatePremisesLicence7Day'];
  return validLicenceIds.includes((licence as CertificatePremisesLicence).licence_type_id);
}